import { makeStyles } from "@material-ui/core";

export const useAdvModalStyles = makeStyles((theme) => ({
  root: (style) => ({
    ...{ ...style, position: "absolute !important" },
    "& .MuiBackdrop-root": { ...style, position: "absolute", zIndex: "0" }
  }),
  "@global": {
    "*::-webkit-input-placeholder": {
      color: "#606060"
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer - 1
  },
  button: {
    position: "relative"
  },
  data: {
    fontSize: "15px",
    fontWeight: "bold"
  },
  dialog: {
    overflow: "hidden",
    direction:
      window?.psh_configs?.selectedLanguage === "ar" ||
      window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "rtl"
        : "ltr",
    borderRadius: "2px",
    margin: "0",
    // height: (style) =>
    //   style?.gridStyle?.GridModalType === "belowSection" && style?.gridStyle.GridModalType === "aboveSection"
    //     ? style?.popupStyle?.AdvListviewPopupAutoHeight === "true"
    //       ? "auto"
    //       : `${style?.popupStyle?.height || 300}px`
    //     : style?.popupStyle?.height
    //     ? `${style?.popupStyle?.height}%`
    //     : "auto",
    height:(style)=> style?.popupStyle?.AdvListviewPopupAutoHeight === "true" || style?.popupStyle.ListviewPopupHeight === "true"? 'auto': style?.popupStyle?.height ? 
        (style?.gridStyle?.GridModalType !== "belowSection" && style?.gridStyle.GridModalType !== "aboveSection") ? `${style?.popupStyle?.height}%`:`${style?.popupStyle?.height || 300}px` :"auto",
    width: (style) =>
      style?.gridStyle?.GridModalType === "belowSection" && style?.gridStyle.GridModalType === "aboveSection"
        ? "100%"
        : style?.popupStyle?.width
        ? `${style?.popupStyle?.width}%`
        : "90%",
    maxWidth: "unset",
    maxHeight:(style) => (style) => style?.popupStyle?.height ? "100%" : "80%",
    backgroundColor: (style) => style?.popupStyle?.AdvListviewBackgroundColor || "#fff",

  },
  dialogTitle: {
    padding: 16,
    width: "100%",
    height: "50px",
    fontSize: "16px !important",
    fontWeight: "600"
  },
  dialogContent: {
    padding: 0,
    width: "100%",
    overflow: "hidden",
    // maxHeight: "500px",
    border: "none",
    overflowY: "auto"
  },
  dialogActions: {
    height: 50,
    width: "100%",
    background: "#F5F5F5 0% 0% no-repeat padding-box",
    opacity: 1,
    padding: "11px 16px 11px"
  },
  btn1: {
    width: "104px",
    height: "28px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: "1px solid #C4C4C4",
    borderRadius: "2px",
    opacity: 1,
    padding: "5px 8px 6px 8px",
    marginRight: "5px",
    marginLeft: "5px"
  },
  btn2: {
    width: "124px",
    height: "28px",
    background: "#0072C6 0% 0% no-repeat padding-box",
    borderRadius: "2px",
    opacity: 1,
    padding: "5px 8px 6px 8px"
  },
  btnlabel: {
    textTransform: "none",
    font: "normal normal 600 12px/17px Open Sans"
  },

  closeIcon: {
    fontSize: 10
  },
  tableContainer: {
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    marginRight: "2.02%",
    marginLeft: "3.16%",
    maxHeight: "252px",
    width: "94.8%",
    padding: "none",
    border: "1px solid #C4C4C4"
  },
  table: {
    minWidth: 300,
    flex: "auto"
  },
  tableHead: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    opacity: 1,
    textAlign: "left",
    font: "normal normal 600 14px/19px OpenSans",
    letterSpacing: "0px",
    color: "#606060",
    height: "36px"
  },
  tableBody: {
    textAlign: "left",
    font: "normal normal 600 14px/19px OpenSans",
    letterSpacing: "0px",
    color: "#000000"
  },
  tableHeadRow: {
    height: "36px"
  },
  tableBodyRow: {
    height: "36px"
  },
  tableHeadCell: {
    font: "normal normal 600 14px/19px  Open Sans",
    height: "auto",
    color: "#606060",
    textAlign:
      window?.psh_configs?.selectedLanguage === "ar" ||
      window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "right"
        : "left"
  },
  tableBodyCell: {
    font: "normal normal 600 14px/19px Open Sans",
    height: "auto",
    textAlign:
      window?.psh_configs?.selectedLanguage === "ar" ||
      window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "right"
        : "left",
    color: "#000000"
  },
  tableCheckCell: {
    padding: "10px 8px 0px 8px",
    width: "30px",
    borderRight: "1px solid #C4C4C4"
  },
  tableInput: {
    border: "1px solid #C4C4C4",
    borderRadius: "2px",
    opacity: 1
  },
  dialogHead: {
    flex: 1,
    display: "flex"
  },
  dialogHead1: {
    textAlign: "left",
    fontSize: "14px",
    font: "normal normal 600 14px/19px Open Sans",
    fontWeight: "600"
  },
  dialogHead2: {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end"
  },
  dialogHeadIcon: {
    height: "15px",
    width: "15px"
  },
  divider: {
    margin: "0 !important",
    backgroundColor: "#E4E4E4"
  },
  dialogContentHead: {
    margin: "2px",
    flex: 1,
    display: "flex"
  },
  allColumns: {
    textAlign: "left",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    color: "#606060",
    opacity: 1,
    fontSize: "12px",
    fontColor: "#C4C4C4",
    border: "1px solid #C4C4C4",
    height: "28px",
    width: "180px",
    margin: "8px 0px 8px 0px"
  },
  searchBox: {
    textAlign: "left",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    color: "#606060",
    opacity: 1,
    fontSize: "12px",
    fontColor: "#C4C4C4",
    border: "1px solid #C4C4C4",
    height: "28px",
    width: "200px",
    margin: "8px 0px 8px 0px"
  },
  searchInput: {
    fontSize: "12px",
    fontColor: "#C4C4C4",
    padding: "6px 0px 2px 8px",
    border: "none",
    outline: "none",
    width: "176px"
  },
  searchIcon: {
    paddingBottom: "5px"
  },
  rightArrowIcon: {
    padding: "0px",
    border: "1px solid #C4C4C4",
    margin: "8px 12px 8px 3px",
    width: "28px",
    height: "28px",
    backgroundColor: "white"
  },
  leftArrowIcon: {
    padding: "0px",
    border: "1px solid #C4C4C4",
    margin: "8px 3px 8px 20px",
    width: "28px",
    height: "28px",
    backgroundColor: "white"
  },
  leftArrowIcon1: {
    padding: "0px",
    border: "1px solid #C4C4C4",
    margin: "8px 3px 8px 12px",
    width: "28px",
    height: "28px",
    backgroundColor: "white"
  },
  rightArrowIcon1: {
    padding: "0px",
    border: "1px solid #C4C4C4",
    margin: "8px 16px 8px 3px",
    width: "28px",
    height: "28px",
    backgroundColor: "white"
  },
  gridButtons: {
    "& .primaryBtn": {
      color: (prop) => prop.PrimaryButton_FontColor || prop.primaryColor,
      backgroundColor: (prop) => prop.PrimaryButton_BackgroundColor || prop.primaryBackgroundColor,
      borderColor: (prop) => prop.PrimaryButton_BorderColor || prop.primaryBorderColor,
      borderWidth: (prop) => prop.PrimaryButton_BorderWidth,
      borderRadius: (prop) => prop.PrimaryButton_BorderRadius,
      fontSize: (prop) => prop.PrimaryButton_FontSize,
      fontFamily: (prop) => prop.PrimaryButton_FontFamily,
      fontWeight: (prop) => prop.PrimaryButton_FontWeight,

      "&:focus": {
        boxShadow: (prop) => `0 0 5px 0px ${prop.PrimaryButton_BorderColor || prop.primaryBorderColor}`
      }
    },
    "& .secondaryBtn": {
      color: (prop) => prop.SecondaryButton_FontColor || prop.secondaryColor,
      borderColor: (prop) => prop.SecondaryButton_BorderColor || prop.secondaryBorderColor,
      backgroundColor: (prop) => prop.SecondaryButton_BackgroundColor,
      borderWidth: (prop) => prop.SecondaryButton_BorderWidth,
      borderRadius: (prop) => prop.SecondaryButton_BorderRadius,
      fontSize: (prop) => prop.SecondaryButton_FontSize,
      fontFamily: (prop) => prop.SecondaryButton_FontFamily,
      fontWeight: (prop) => prop.SecondaryButton_FontWeight,

      "&:focus": {
        boxShadow: (prop) => `0 0 5px 0px ${prop.SecondaryButton_BorderColor || prop.secondaryBorderColor}`
      }
    }
  }
}));
